import React, { useState ,useEffect} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceListLayer from "../components/InvoiceListLayer";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { API_URL } from "..";




const InvoiceListPage = () => {

  const [data, setData]=useState([])
  const [dataDasboard, setDataDashboard]=useState({
    total_invoice_amount:0,
    received_invoice_amount: 0,
    overdue_invoice_amount: 0,
    totalRow: 0,
    overdueRow:0,
    receivedRow:0
  })
  const fetchInvoices =  async()=>{
      const user = JSON.parse(localStorage.getItem('user'));
      if(!user){
        window.location.href='/sign-in'
      }else{
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
        let response = await fetch( `${API_URL}/api/invoice/${user.id}`, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();

        setData(data.invoices)
        setDataDashboard({
          total_invoice_amount:data?.total_invoice_amount,
          received_invoice_amount:data?.received_invoice_amount,
          overdue_invoice_amount:data?.overdue_invoice_amount,
          totalRow: data?.totalRow,
          overdueRow:data?.overdueRow,
          receivedRow:data?.receivedRow
        })
      }
      
  }
  useEffect(()=>{
    fetchInvoices();
  },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Invoice" />
        <p>Create and manage all invoices generated by your business.</p>

        {/* InvoiceListLayer */}
        <div className="row mb-3" style={{ rowGap: 10 }}>
                          <div className="col-md-3">
                            <div className="card p-3 shadow-none border bg-gradient-start-1 h-100">
                              <Link to={"/invoices/all"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                          <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            ({dataDasboard?.totalRow}) Invoice
                                          </span>
                                          <h6 className="fw-semibold">
                                            {/* {data?.totalAffiliates} */}
                                            ${parseFloat(dataDasboard?.total_invoice_amount).toFixed(2) || 0.00}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="card p-3 shadow-2 radius-8 border input-form-light bg-gradient-end-3">
                              <Link to={"/invoices/overdue"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-48-px h-48-px bg-warning-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                          ({dataDasboard.overdueRow}) Overdue
                                          </span>
                                          <h6 className="fw-semibold">
                                           ${parseFloat(dataDasboard?.overdue_invoice_amount).toFixed(2) || 0} {/* {data?.activeAffiliates} */}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="card p-3 shadow-2 radius-8 border input-form-light bg-gradient-end-2">
                              <Link to={"/invoices/received"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-48-px h-48-px bg-success text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            ({dataDasboard.receivedRow}) Received 
                                          </span>
                                          <h6 className="fw-semibold">
                                          ${parseFloat(dataDasboard?.received_invoice_amount).toFixed(2) || 0}
                                             
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                        
                          
                        </div>
        {
          data.length== 0 ? null :
          <InvoiceListLayer jobsData={data}/>
        }

      </MasterLayout>

    </>
  );
};

export default InvoiceListPage;
